<template>
  <div class="about-match">
    <div class="about-match-title">
      <div class="about-match-title-text">关于大赛</div>
    </div>
    <div class="about-match-content">
      <div class="item-view" style="">
        <div class="view">
          <div
            class="about-match-content-dsgk"
            @click="handleShowDetail('大赛概况')"
          >
            <p class="about-match-content-dsgk-text dasai-text">
              大赛<br>概况
            </p>
          </div>
        </div>
        <div class="view">
          <div
            class="about-match-content-dstz"
            @click="handleShowDetail('大赛通知')"
          >
            <p class="about-match-content-dsgk-text dasai-text-left">
              大赛<br>通知
            </p>
          </div>
        </div>
      </div>

      <div class="item-view">
        <div class="view">
          <div
            class="about-match-content-zzjg"
            @click="handleShowDetail('组织机构')"
          >
            <p class="about-match-content-zzjg-text dasai-text">
              组织<br>机构
            </p>
          </div>
        </div>
        <div class="view">
          <div
            class="about-match-content-dszc"
            @click="handleShowDetail('大赛章程')"
          >
            <p class="about-match-content-dstz-text dasai-text-left">
              大赛<br>章程
            </p>
          </div>
        </div>
      </div>
      <div class="item-view">
        <div class="view">
          <div
            class="about-match-content-ssgz"
            @click="handleShowDetail('赛事规则')"
          >
            <p class="about-match-content-ssgz-text dasai-text">
              赛事<br>规则
            </p>
          </div>
        </div>
        <div class="view">
          <div
            class="about-match-content-dslx"
            @click="handleShowDetail('大赛联系')"
          >
            <p class="about-match-content-ssgz-text dasai-text-left">
              大赛<br>联系
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {},

  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getContent()
  },
  methods: {
    handleShowDetail (title) {
      console.log('title', title)
      this.list.forEach(item => {
        if (item.title === title) {
          console.log(item)
          this.$router.push({
            path: '/AboutCompetition',
            query: {
              id: item.id
            }
          })
        }
      })
    },
    getContent () {
      var url = this.siteURL + '/actuator/channel/list?siteId=' + this.siteId + '&url=/AboutCompetition'
      this.axios.get(url, {}).then(response => {
        this.channelId = response.data.rows[0].id
        var api = this.siteURL + '/actuator/article/indexList?channelId=' + this.channelId
        this.axios.get(api, {}).then(response => {
          this.list = response.data.rows
          console.log(response.data.rows)
        })
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.about-match {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &-title {
    width: 80%;
    margin: 0;
    height: 78px;
    background-image: url("~@/assets/images/title_bg.png");
    background-position: center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    &-text {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 30px;
      color: #ffffff;
      text-align: right;
      font-style: normal;
      margin-left: 100px;
    }
  }

  &-content {
    margin-top: 18px;
    background-image: url("~@/assets/images/dasai_bg.png");
    background-position: center;
    background-size: 100% 100%;
    width: 100%;
    cursor: pointer;
    padding: 20px 20px 0 20px;

    .item-view {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;

      .view {
        width: 47%;
      }
    }

    &-dsgk {
      width: 100%;
      height: 120px;
      background-image: url("~@/assets/images/dasaigaikuang_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
    }

    &-zzjg {
      width: 100%;
      height: 120px;
      background-image: url("~@/assets/images/zuzhijigou_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;

    }

    &-dstz {
      width: 100%;
      height: 120px;
      background-image: url("~@/assets/images/dasaitongzhi _bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
    }
    &-dszc {
      width: 100%;
      height: 120px;
      background-image: url("~@/assets/images/dasaizhangcheng_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
    }

    &-ssgz {
      width: 100%;
      height: 120px;
      background-image: url("~@/assets/images/saishiguize_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
    }
    &-dslx {
      width: 100%;
      height: 120px;
      background-image: url("~@/assets/images/dasailianxi_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
    }
  }

  .dasai-text {
    width: 90%;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
    line-height: 26px;
    text-shadow: 0px 2px 4px #2585b9;
    text-align: right;
    font-style: normal;
  }

  .dasai-text-left {
    width: 70%;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 20px;
    color: #ffffff;
    line-height: 26px;
    text-shadow: 0px 2px 4px #2585b9;
    text-align: left;
    font-style: normal;
    margin-left: 10%;
  }
}

@media screen and (max-width: 767px) {
  .about-match {
    flex: 1;
    width: 100%;
    display: flex;
    margin-top: 20px;

    &-title {
      width: 80%;
      margin: 0;
      height: 78px;
      background-image: url("~@/assets/images/title_bg.png");
      background-position: center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;

      &-text {
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 18px;
        color: #ffffff;
        line-height: 55px;
        text-align: right;
        font-style: normal;
        margin-left: 120px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/part2/AboutMatch.vue